<template>
  <div class="w-full">
    <div class="resource-documents-wrap">
      <div class="resource-documents-header">
        <h3 class="resource-documents-title">Resource Documents</h3>
        <p class="resource-documents-subtitle">
          Resources and reports are grouped here for easier access.
        </p>
      </div>

      <div class="resource-documents-tabs">
        <button
          type="button"
          @click="activeTab = 'resources'"
          class="resource-tab-btn"
          :class="activeTab === 'resources' ? 'resource-tab-btn-active' : ''"
        >
          Resources
        </button>

        <button
          type="button"
          @click="activeTab = 'reports'"
          class="resource-tab-btn"
          :class="activeTab === 'reports' ? 'resource-tab-btn-active' : ''"
        >
          Reports
        </button>
      </div>

      <div class="resource-documents-content">
        <resources-view v-if="activeTab === 'resources'" />
        <reports-view v-if="activeTab === 'reports'" />
      </div>
    </div>
  </div>
</template>

<script>
import ResourcesView from "@/views/main/Resources.vue";
import ReportsView from "@/views/main/Reports.vue";

export default {
  name: "ResourceDocuments",
  components: {
    ResourcesView,
    ReportsView,
  },
  data() {
    return {
      activeTab: "resources",
    };
  },
};
</script>

<style scoped>
.resource-documents-wrap {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.08);
  padding: 1rem;
}

.resource-documents-header {
  margin-bottom: 1rem;
}

.resource-documents-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.resource-documents-subtitle {
  color: #64748b;
  font-size: 0.95rem;
}

.resource-documents-tabs {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.resource-tab-btn {
  background: #e2e8f0;
  color: #334155;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.7rem 1rem;
  border-radius: 9999px;
  transition: all 0.18s ease;
}

.resource-tab-btn:hover {
  background: #cbd5e1;
}

.resource-tab-btn-active {
  background: #14b8a6;
  color: white;
}

.resource-documents-content {
  width: 100%;
}

@media (max-width: 767px) {
  .resource-documents-wrap {
    padding: 0.85rem;
  }

  .resource-documents-tabs {
    flex-direction: column;
  }

  .resource-tab-btn {
    width: 100%;
    text-align: center;
  }
}
</style>
